import { useCallback, useContext } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import SpmConstants from 'sg-spm-constants';
import metadata from './SgVehicleSummary.metadata.json5';
import messages from './SgVehicleSummary.messages';

function SgVehicleSummary(props) {
    const translator = useContext(TranslatorContext);
    const {
        vehicleModel,
        changeVehicleView,
        isReadOnly
    } = props;

    const toManualLookup = useCallback(() => {
        changeVehicleView(SpmConstants.VEHICLE_LOOKUP_VIEWS.MANUAL_LOOKUP, 'edit');
    }, [changeVehicleView]);

    const toRegLookup = useCallback(() => {
        changeVehicleView(SpmConstants.VEHICLE_LOOKUP_VIEWS.REGISTRATION_LOOKUP);
    }, [changeVehicleView]);

    const overrideProps = {
        reg: {
            content: vehicleModel.registrationNumber.value,
        },
        make: {
            content: vehicleModel.make.value,
        },
        model: {
            content: vehicleModel.model.value,
        },
        engineCapacity: {
            content: vehicleModel.engineCapacity.value,
        },
        yearOfRegistration: {
            content: vehicleModel.year.value,
        },
        description: {
            content: vehicleModel.description.value,
        },
        editVehicle: {
            visible: !isReadOnly ? '' : false,
            content: translator(messages.editVehicle)
        },
        newRegLink: {
            visible: !isReadOnly ? '' : false,
            content: vehicleModel.registrationNumber.value ? translator(messages.changeRegistration) : translator(messages.enterRegistration),
            className: vehicleModel.registrationNumber.value ? 'sgChangeRegistrationLink' : 'sgEnterRegistrationLink'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            toRegLookup,
            toManualLookup
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

export default SgVehicleSummary;
